import styled from "styled-components";
const LabelTextImpl = styled("span")(
  ({ theme }) => ({
    fontWeight: theme.fontWeight.normal,
    margin: 0,
    padding: 0
  }),
  ({ theme, $displayMode }) => ({
    color: $displayMode === "dark" ? theme.color.white10 : theme.color.gray9
  })
);
export {
  LabelTextImpl
};
